import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiRateRepositoryBuilder } from './WapiRateRepository'

export const wapiRateRepository = () => {
  return wapiRateRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
